import { UserType } from '@app-types/user';

export type ContactDetailsType = {
    address: {
        zipCode?: string;
        city?: string;
    };
};

export type BuyerContextType = {
    user?: UserType;
    idPu?: string;
    address?: ContactDetailsType['address'];
};

export enum PersonType {
    GP = 'INDIVIDU',
    PRO = 'ENTREPRISE',
}

export type PersonDetailsType = {
    id: string;
    type: PersonType;
};
